import React from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const EngageConfirmDialog = ({
  open,
  title,
  body,
  cancelLabel,
  confirmLabel,
  onCancel,
  onConfirm,
  confirmColor = 'primary',
  icon = null,
  confirmPending = false,
}) => {
  const requestClose = () => {
    if (confirmPending) return;
    onCancel();
  };

  return (
    <Dialog open={open} onClose={requestClose} maxWidth='xs' fullWidth>
      <DialogTitle sx={{ fontWeight: 700, pr: 6 }}>
        {icon ? <Box mb={1.5}>{icon}</Box> : null}
        {title}
        <IconButton aria-label='Close' onClick={requestClose} sx={{ position: 'absolute', right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant='body2' color='text.secondary'>
          {body}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button variant='outlined' onClick={requestClose} disabled={confirmPending} sx={{ textTransform: 'none', fontWeight: 600 }}>
          {cancelLabel}
        </Button>
        <Button
          variant='contained'
          color={confirmColor}
          onClick={onConfirm}
          disabled={confirmPending}
          sx={{ textTransform: 'none', fontWeight: 600 }}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EngageConfirmDialog;
